import { Component, OnInit, Input } from '@angular/core';
import { User } from 'src/app/models';

@Component({
    selector: 'wm-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.css'],
    standalone: false
})
export class UserInfoComponent implements OnInit {
  @Input() user: User;

  constructor() { }

  ngOnInit() {
  }

}
